import { Text } from '@factorialco/deprecated-design-system'
import uniq from 'lodash/uniq'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import { supplementTaxonomyName } from 'modules/contracts/store/collections/taxonomies'
import supplementBulkImportCollection from 'modules/payroll_bundle/store/collections/supplementBulkImports'

import SupplementsListItem from './SupplementsListItem'

const SupplementsList = () => {
  const listInfo = supplementBulkImportCollection.map((supplementsImport) => {
    const uploadDate = moment(supplementsImport.attributes.created_at)
    const supplements = supplementsImport.supplements
    let taxonomies: string[] = []
    let amount = 0

    supplements.forEach((supplement) => {
      amount += supplement.attributes.amount_in_cents
      taxonomies.push(supplementTaxonomyName(supplement))
    })

    taxonomies = uniq(taxonomies)

    const listData = {
      taxonomies,
      supplements,
      timestamp: uploadDate.format('MMM Do, HH:mm'),
      amount,
      id: supplementsImport.attributes.id,
      filename: supplementsImport.attributes.filename,
      author: users.get(supplementsImport.attributes.author_id)?.legalName,
    }

    return listData
  })

  if (supplementBulkImportCollection.length === 0) {
    return (
      <Text.Normal>
        {i18n.t('payroll_bundle.manage_imported_supplements.nothing_found')}
      </Text.Normal>
    )
  }

  return (
    <>
      {listInfo.map((listItem) => {
        return <SupplementsListItem listItem={listItem} key={listItem.id} />
      })}
    </>
  )
}

export default SupplementsList
